import { render, staticRenderFns } from "./CompArticleInfographic.vue?vue&type=template&id=7b8ce449"
import script from "./CompArticleInfographic.vue?vue&type=script&setup=true&lang=js"
export * from "./CompArticleInfographic.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports